export default "__VITE_ASSET__C8GCjN79__"